// libs
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import { mapResourceModules } from '@reststate/vuex'
import api from '@/api'
// Modules
import currentDateRange from './modules/current-date-range'
import selectedTab from './modules/selected-tab'
import selectedTaskFilter from './modules/selected-task-filter'
import currentEntry from './modules/current-entry'
import syncStatus from './modules/sync-status'
import selectedUsers from './modules/selected-users'
import pausedEntry from './modules/paused-entry'
import versions from './modules/versions'
import app from './modules/app'
import timeEntries from './modules/time-entries'
import tasksModule from './modules/tasks'
import filteredEntries from './modules/filtered-entries'
import authentication from './modules/authentication'
import usersModule from './modules/users'

Vue.use(Vuex)
// Local storage
const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    currentDateRange: state.currentDateRange,
    selectedTab: state.selectedTab,
    selectedTaskFilter: state.selectedTaskFilter,
    authentication: state.authentication,
    pausedEntry: state.pausedEntry,
    app: state.app,
    timeEntries: state.timeEntries,
    tasks: app.tasksModule
  })
})

// Vuex Store
export default new Vuex.Store({
  modules: {
    ...mapResourceModules({
      names: ['time-entries', 'tasks', 'clients', 'projects', 'time-entry-notes', 'users', 'activities', 'roles', 'flux-roles', 'events', 'milestones', 'lp-sync-statuses', 'teams'],
      httpClient: api
    }),
    currentDateRange,
    selectedTab,
    selectedTaskFilter,
    selectedUsers,
    versions,
    currentEntry,
    syncStatus,
    pausedEntry,
    app,
    timeEntries,
    filteredEntries,
    tasksModule,
    authentication,
    usersModule
  },
  plugins: [vuexLocalStorage.plugin]
})
